import { styled } from 'styled-components'

export const WrapperLoader = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`
